(function(){
  'use strict';
  var header=document.querySelector('.site-header');
  if(header){window.addEventListener('scroll',function(){if(window.scrollY>40)header.classList.add('scrolled');else header.classList.remove('scrolled')})}
  var mt=document.querySelector('[data-menu-toggle]'),mm=document.querySelector('[data-mobile-menu]');
  if(mt&&mm){mt.addEventListener('click',function(){mm.classList.toggle('open')})}
  document.querySelectorAll('[data-filter]').forEach(function(btn){
    btn.addEventListener('click',function(){
      var f=btn.getAttribute('data-filter');
      document.querySelectorAll('[data-filter]').forEach(function(b){b.classList.toggle('active',b===btn)});
      document.querySelectorAll('[data-product-item]').forEach(function(card){
        var cat=card.getAttribute('data-category')||'';
        var tags=(card.getAttribute('data-tags')||'').split('|');
        card.style.display=(f==='all'||cat===f||tags.indexOf(f)>-1)?'':'none'
      })
    })
  });
  function toast(msg){var t=document.getElementById('toast');if(!t){t=document.createElement('div');t.id='toast';t.className='toast';document.body.appendChild(t)}t.textContent=msg;t.classList.add('show');clearTimeout(window.__toastT);window.__toastT=setTimeout(function(){t.classList.remove('show')},2400)}
  window.__bnToast=toast;
  document.querySelectorAll('form[data-add-form]').forEach(function(form){
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var fd=new FormData(form);
      var title=form.getAttribute('data-title')||'Reading';
      fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:fd})
        .then(function(r){return r.json()}).then(function(){
          toast('Added to cart \u2014 '+title);
          fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(c){
            document.querySelectorAll('[data-cart-count]').forEach(function(el){el.textContent=c.item_count;if(c.item_count===0)el.classList.add('is-empty');else el.classList.remove('is-empty')});
          });
        })
        .catch(function(){toast('Something went wrong')})
    })
  });
  var calc=document.getElementById('calc-form');
  if(calc){
    var meanings={
      1:{t:'The Leader',x:'Independent, pioneering, born to lead. Your money comes when you stop asking for permission.'},
      2:{t:'The Peacemaker',x:'Sensitive, diplomatic, powerful in partnership. Your fortune arrives through cooperation, not force.'},
      3:{t:'The Creator',x:'Expressive, magnetic, wired for influence. Your voice is your currency \u2014 use it publicly.'},
      4:{t:'The Builder',x:'Disciplined, methodical, wealth-through-structure. Systems, not sparks, will make you rich.'},
      5:{t:'The Adventurer',x:'Free-spirited, versatile, allergic to routine. Your money loves movement, travel and change.'},
      6:{t:'The Nurturer',x:'Responsible, healing, wealth through service. Your gift is helping others become their best.'},
      7:{t:'The Mystic',x:'Deep, analytical, spiritually wired. Your riches come from mastery of a niche, not the crowd.'},
      8:{t:'The Powerhouse',x:'Ambitious, executive, born for large-scale wealth. This is the classic money number \u2014 own it.'},
      9:{t:'The Humanitarian',x:'Wise, generous, global in vision. Your wealth expands when your mission expands beyond you.'},
      11:{t:'The Illuminator',x:'You carry rare, intuitive genius. Fame, influence and legacy are on your path \u2014 if you dare.'},
      22:{t:'The Master Builder',x:'The most powerful number in numerology. You are here to build something that outlives you.'},
      33:{t:'The Master Teacher',x:'Rare and sacred. You are here to elevate humanity through your work.'}
    };
    function reduce(n){while(n>9&&n!==11&&n!==22&&n!==33){n=String(n).split('').reduce(function(a,b){return a+ +b},0)}return n}
    calc.addEventListener('submit',function(e){
      e.preventDefault();
      var d=document.getElementById('calc-dob').value;if(!d)return;
      var sum=d.replace(/-/g,'').split('').reduce(function(a,b){return a+ +b},0);
      var lp=reduce(sum);var m=meanings[lp]||meanings[9];
      document.getElementById('res-num').textContent=lp;
      document.getElementById('res-title').textContent=m.t;
      document.getElementById('res-text').textContent=m.x;
      var r=document.getElementById('calc-result');r.classList.add('show');
      setTimeout(function(){r.scrollIntoView({behavior:'smooth',block:'center'})},80)
    })
  }
})();

// Cart quantity +/- buttons
document.addEventListener('click', function(e){
  var line = e.target.closest('.cart-line');
  if(!line) return;
  var input = line.querySelector('.qty-input');
  if(!input) return;
  if(e.target.matches('[data-qty-plus]')){
    input.value = (parseInt(input.value,10)||0) + 1;
    input.dispatchEvent(new Event('change', {bubbles:true}));
  } else if(e.target.matches('[data-qty-minus]')){
    var v = (parseInt(input.value,10)||0) - 1;
    input.value = v < 0 ? 0 : v;
    input.dispatchEvent(new Event('change', {bubbles:true}));
  }
});

// Cart AJAX quantity change + remove
(function(){
  var form = document.getElementById('cart-form');
  if(!form) return;
  var moneyFmt = form.getAttribute('data-money-format') || '${{amount}}';
  function fmt(cents){
    var n = (cents/100);
    return moneyFmt.replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/, function(_,nd){
      if(nd) return Math.round(n).toLocaleString();
      return n.toFixed(2);
    }).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.toFixed(2).replace('.',','));
  }
  function refreshCart(cart){
    var subtotalEl = form.querySelector('[data-cart-subtotal]');
    if(subtotalEl) subtotalEl.textContent = fmt(cart.total_price);
    document.querySelectorAll('[data-cart-count]').forEach(function(el){
      el.textContent = cart.item_count;
      if(cart.item_count===0) el.classList.add('is-empty'); else el.classList.remove('is-empty');
    });
    (cart.items||[]).forEach(function(it){
      var line = form.querySelector('.cart-line[data-line-key="'+it.key+'"]');
      if(!line) return;
      var totalEl = line.querySelector('[data-line-total]');
      var qtyIn = line.querySelector('[data-qty-input]');
      if(totalEl) totalEl.textContent = fmt(it.final_line_price || it.line_price);
      if(qtyIn) qtyIn.value = it.quantity;
    });
    // remove lines that no longer exist
    var keys = (cart.items||[]).map(function(i){return i.key});
    form.querySelectorAll('.cart-line').forEach(function(line){
      if(keys.indexOf(line.getAttribute('data-line-key')) === -1) line.remove();
    });
    if(cart.item_count===0) window.location.reload();
  }
  function change(key, quantity){
    return fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
      body: JSON.stringify({id: key, quantity: quantity})
    }).then(function(r){return r.json()}).then(refreshCart);
  }
  // debounce per input
  var timers = {};
  form.addEventListener('click', function(e){
    var line = e.target.closest('.cart-line'); if(!line) return;
    var key = line.getAttribute('data-line-key');
    var input = line.querySelector('[data-qty-input]');
    if(e.target.matches('[data-qty-plus]')){
      var v = (parseInt(input.value,10)||0) + 1;
      input.value = v;
      change(key, v);
    } else if(e.target.matches('[data-qty-minus]')){
      var v = Math.max(0, (parseInt(input.value,10)||0) - 1);
      input.value = v;
      change(key, v);
    } else if(e.target.matches('[data-remove-line]')){
      e.preventDefault();
      change(key, 0);
    }
  });
  form.addEventListener('change', function(e){
    if(!e.target.matches('[data-qty-input]')) return;
    var line = e.target.closest('.cart-line');
    var key = line.getAttribute('data-line-key');
    var v = Math.max(0, parseInt(e.target.value,10)||0);
    clearTimeout(timers[key]);
    timers[key] = setTimeout(function(){ change(key, v); }, 250);
  });
  // Save note + attributes on checkout submit (Shopify handles this automatically via the form fields with proper names)
})();
